
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generic-error",
      function () {
        return require("private-next-pages/generic-error.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/generic-error"])
      });
    }
  